/*
 * @Author: weiShu
 * @Date: 2025-12-29 15:40:44
 * @LastEditors: weiShu
 * @LastEditTime: 2025-12-31 14:08:54
 * @FilePath: \health-commission-new\src\utils\server.js
 * @Description:
 */
import Vue from 'vue'
import axios from 'axios'
import router from '@/router/index.js'
import store from '@/store/index.js'
import { removeToken } from '@/utils/auth.js'

import { Toast } from 'vant'

Vue.use(Toast)

axios.defaults.withCredentials = true

const httpConfig = {
  baseURL: process.env.NODE_ENV == 'development' ? '/api/api' : process.env.VUE_APP_API_URL + '/api',
  timeout: 20000,
  withCredentials: true
}

const instance = axios.create(httpConfig)

instance.interceptors.request.use(
  config => {
    if (config.formData) {
      const formData = new FormData()
      for (const key in config.formData) {
        formData.append(key, config.formData[key])
      }
      config.data = formData
    }
    return config
  },
  err => Promise.reject(err)
)

instance.interceptors.response.use(
  response => {
    const res = response.data

    if (res.code == 200) {
      return res
    } else if (res.code == 10032) {
      store.commit('clearExamInfo')
      if (router.currentRoute.path !== '/evaluation') {
        router.replace('/evaluation')
      }
      Toast(res.msg ? res.msg : '\u8003\u8bd5\u5df2\u7ed3\u675f')
      return Promise.reject(res)
    } else if (res.code == 2) {
      store.commit('clearUserInfo')
      removeToken()
      if (router.currentRoute.path !== '/login') {
        router.replace({
          path: '/login',
          query: {
            redirect: router.currentRoute.fullPath
          }
        })
      }
      Toast(res.msg ? res.msg : '\u8bf7\u5148\u767b\u5f55')
      return Promise.reject(res)
    } else {
      Toast(res.msg ? res.msg : '\u7cfb\u7edf\u7e41\u5fd9')
      return Promise.reject(res)
    }
  },
  error => {
    console.log('error' + error)
    return Promise.reject(error)
  }
)

export default instance
